import { Controller } from "@hotwired/stimulus"

// The landing page's "Prøv selv" demo: a local-only wish list. Type a wish and
// press Enter (or "Legg til") to append a card cloned from the <template>; each
// card has a qty stepper and a remove button. Nothing is submitted — saving
// requires an account.
//
//   .try-card{data: {controller: "try-list"}}
//     input{data: {try_list_target: "composer", action: "keydown.enter->try-list#add"}}
//     button{data: {action: "try-list#add"}}
//     div{data: {try_list_target: "cards"}} …cards…
//     template{data: {try_list_target: "template"}} …NEW_RECORD card…
export default class extends Controller {
  static targets = ["composer", "cards", "template"]

  connect() {
    this.seq = 0
  }

  add(event) {
    if (event) event.preventDefault()
    const name = this.composerTarget.value.trim()
    if (!name) return
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, `${Date.now()}${++this.seq}`)
    this.cardsTarget.insertAdjacentHTML("beforeend", html)
    const card = this.cardsTarget.lastElementChild
    const input = card.querySelector("[data-wish-name]")
    if (input) input.value = name
    // Pop-art "fly down & land" on the fresh card.
    card.classList.add("wish-pop")
    setTimeout(() => card.classList.remove("wish-pop"), 750)
    this.composerTarget.value = ""
    this.composerTarget.focus()
  }

  remove(event) {
    event.preventDefault()
    const card = event.target.closest("[data-try-wish]")
    if (card) card.remove()
  }

  incQty(event) { this.stepQty(event, +1) }
  decQty(event) { this.stepQty(event, -1) }

  stepQty(event, delta) {
    event.preventDefault()
    const card = event.target.closest("[data-try-wish]")
    if (!card) return
    const input = card.querySelector("[data-wish-qty]")
    const display = card.querySelector("[data-wish-qty-display]")
    const next = Math.max(1, (parseInt(input.value, 10) || 1) + delta)
    input.value = next
    if (display) display.textContent = next
  }
}
